var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MhRouterView',{staticClass:"DevView view hSpace hSpace--app",attrs:{"isContentReady":_vm.isContentReady}},[_c('div',{staticClass:"view__inner"},[_c('br'),_c('strong',[_vm._v("DevView.vue")]),_c('hr'),_c('br')])])}
var staticRenderFns = []

export { render, staticRenderFns }